import { createAsyncAction } from "typesafe-actions";
import { TopicsListReply, TopicCreateReply } from "dialup";

export const listTopicsProgress = createAsyncAction(
  "LIST_TOPICS_REQUEST",
  "LIST_TOPICS_SUCCESS",
  "LIST_TOPICS_FAILURE"
)<void, TopicsListReply, Error>();

export const createTopicProgress = createAsyncAction(
  "CREATE_TOPIC_REQUEST",
  "CREATE_TOPIC_SUCCESS",
  "CREATE_TOPIC_FAILURE"
)<void, TopicCreateReply, Error>();



// WEBPACK FOOTER //
// ./src/actions/topicActions.ts